import { API_BASE } from "./api";

// Client for dubu-api's order endpoints (auth-gated; session cookies).

export interface ProOrder {
  id: string;
  symbol: string;
  side: "buy" | "sell";
  type: "market" | "limit";
  status: string;
  price: string | null;
  quantity: string;
  filled_quantity: string;
  filled_value: string;
  created_at: string;
}

const req = async <T>(path: string, init: RequestInit = {}): Promise<T> => {
  const res = await fetch(`${API_BASE}${path}`, {
    ...init,
    credentials: "include",
    headers: { "Content-Type": "application/json", ...(init.headers ?? {}) },
  });
  const body = await res.json().catch(() => null);
  if (!res.ok || !body?.success) throw new Error(body?.message || `Request failed (${res.status})`);
  return body.data as T;
};

export const submitOrder = (input: {
  side: "buy" | "sell";
  type: "market" | "limit";
  quantity: string;
  price?: string;
}) => req<ProOrder>("/pro/orders", { method: "POST", body: JSON.stringify(input) });

export const fetchOrders = () => req<{ orders: ProOrder[] }>("/pro/orders");

export const cancelOrder = (id: string) =>
  req<ProOrder>(`/pro/orders/${id}`, { method: "DELETE" });

export const OPEN_STATUSES = ["placing", "pending_settlement", "new", "open", "partially_filled"];
